<!-- ── Loading ──────────────────────────────────────────────── -->
<ng-container *ngIf="!ready">
  <div class="rd-loading">
    <div class="rd-loading__dots"><span></span><span></span><span></span></div>
    <p class="rd-loading__text">Cargando datos…</p>
  </div>
</ng-container>

<!-- ── Content ─────────────────────────────────────────────── -->
<ng-container *ngIf="ready">

  <!-- Header -->
  <div class="rd-header">
    <div class="rd-header__left">
      <div class="rd-header__icon-wrap"
           [class.rd-icon--green]="sentence === 'Ingresos cobrados' || sentence === 'Gastos pagados'"
           [class.rd-icon--orange]="sentence === 'Ingresos no cobrados'"
           [class.rd-icon--red]="sentence === 'Gastos no pagados'">
        <mat-icon *ngIf="sentence === 'Ingresos cobrados' || sentence === 'Gastos pagados'">check_circle</mat-icon>
        <mat-icon *ngIf="sentence === 'Ingresos no cobrados'">schedule</mat-icon>
        <mat-icon *ngIf="sentence === 'Gastos no pagados'">warning</mat-icon>
      </div>
      <div>
        <h2 mat-dialog-title class="rd-header__title">{{ sentence }}</h2>
        <p class="rd-header__sub">{{ dataSource.length }} registro{{ dataSource.length !== 1 ? 's' : '' }}</p>
      </div>
    </div>

    <div class="rd-header__actions">
      <ng-container *ngIf="expenses">
        <button mat-icon-button class="rd-export-btn" (click)="export()" matTooltip="Exportar a Excel">
          <mat-icon>file_download</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="expenses && sentence === 'Gastos no pagados'">
        <button mat-icon-button class="rd-export-btn" (click)="exportExpiration('expenses')" matTooltip="Vencimiento a 5 días">
          <mat-icon>event_busy</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="expenses && sentence === 'Ingresos no cobrados'">
        <button mat-icon-button class="rd-export-btn" (click)="exportExpiration('incomes')" matTooltip="Vencimiento a 5 días">
          <mat-icon>event_busy</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="salary">
        <button mat-icon-button class="rd-export-btn" (click)="exportSalary()" matTooltip="Exportar Nóminas">
          <mat-icon>file_download</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="selfEmployed">
        <button mat-icon-button class="rd-export-btn" (click)="exportSelfEmployed()" matTooltip="Exportar Cuotas Autónomo">
          <mat-icon>file_download</mat-icon>
        </button>
      </ng-container>
      <button mat-icon-button class="rd-close-btn" (click)="closeDialog()" matTooltip="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Sub-navegación "Gastos pagados" -->
  <div class="rd-subnav" *ngIf="sentence.includes('Gastos pagados')">
    <button class="rd-subnav__btn" [class.active]="expenses && !salary && !selfEmployed" (click)="goExpenses()">
      <mat-icon>receipt</mat-icon> Gastos
    </button>
    <button class="rd-subnav__btn" [class.active]="salary" (click)="goSalary()">
      <mat-icon>people</mat-icon> Nóminas
    </button>
    <button class="rd-subnav__btn" [class.active]="selfEmployed" (click)="goSelfEmployed()">
      <mat-icon>person</mat-icon> Cuotas autónomo
    </button>
  </div>

  <mat-dialog-content class="rd-content">

    <!-- Tabla: Ingresos cobrados -->
    <ng-container *ngIf="expenses && salary === false && selfEmployed === false && sentence.includes('Ingresos cobrados')">
      <app-table [columns]="headerTableInvoices" [dataSource]="dataSource" [hasButton]="true"
        [actionsTemplate]="actionsButtonsTi"
        (invoiceNumberClick)="onInvoiceNumberClick($event)">
      </app-table>
    </ng-container>

    <!-- Tabla: Gastos pagados -->
    <ng-container *ngIf="expenses && salary === false && selfEmployed === false && sentence.includes('Gastos pagados')">
      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
        [actionsTemplate]="actionsButtons" [styleRowPendingPay]="'row_color_red'"
        (invoiceNumberClick)="onInvoiceNumberClick($event)">
      </app-table>
    </ng-container>

    <!-- Tabla: Gastos no pagados -->
    <ng-container *ngIf="expenses && salary === false && selfEmployed === false && sentence.includes('Gastos no pagados')">
      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
        [actionsTemplate]="actionsButtons" [styleRowPendingPay]="'row_color_red'" [hasHeaderActions]="true"
        [headerActionsTemplate]="headerActionsButtonsExpenses" [hasSelect]="true"
        (invoiceNumberClick)="onInvoiceNumberClick($event)"
        (amountNumberClick)="onAmountNumberClick($event)">
      </app-table>
    </ng-container>

    <!-- Tabla: Ingresos no cobrados -->
    <ng-container *ngIf="expenses && salary === false && selfEmployed === false && sentence.includes('Ingresos no cobrados')">
      <app-table [columns]="headerTableInvoices" [dataSource]="dataSource" [hasButton]="true"
        [actionsTemplate]="actionsButtons" [styleRowPendingPay]="'row_color_green'" [hasHeaderActions]="true"
        [headerActionsTemplate]="headerActionsButtonsInvoices" [hasSelect]="true"
        (invoiceNumberClick)="onInvoiceNumberClick($event)"
        (amountNumberClick)="onAmountNumberClick($event)">
      </app-table>
    </ng-container>

    <!-- Nóminas -->
    <ng-container *ngIf="salary && selfEmployed === false && expenses === false">
      <div class="rd-loading" *ngIf="!salaryReady">
        <div class="rd-loading__dots"><span></span><span></span><span></span></div>
        <p class="rd-loading__text">Cargando nóminas…</p>
      </div>
      <ng-container *ngIf="salaryReady">
        <app-table [columns]="salaryTable" [dataSource]="salariesDataSource"></app-table>
      </ng-container>
    </ng-container>

    <!-- Cuotas autónomo -->
    <ng-container *ngIf="selfEmployed && salary === false && expenses === false">
      <div class="rd-loading" *ngIf="!selfEmployedReady">
        <div class="rd-loading__dots"><span></span><span></span><span></span></div>
        <p class="rd-loading__text">Cargando cuotas…</p>
      </div>
      <ng-container *ngIf="selfEmployedReady">
        <app-table [columns]="selfEmployedTable" [dataSource]="selfEmployedsSource"></app-table>
      </ng-container>
    </ng-container>

  </mat-dialog-content>
</ng-container>

<!-- ── Action templates ─────────────────────────────────────── -->

<ng-template #actionsButtonsTi let-uid="uid">
  <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
    <button mat-menu-item *ngIf="row.invoiceNumber.startsWith('FRA')" (click)="pdf(row.uid)">
      <mat-icon>picture_as_pdf</mat-icon><span>PDF</span>
    </button>
    <button mat-menu-item *ngIf="row.invoiceNumber.startsWith('TICKET')" (click)="pdfTicket(row.uid)">
      <mat-icon>picture_as_pdf</mat-icon><span>PDF</span>
    </button>
  </ng-container>
</ng-template>

<ng-template #headerActionsButtonsExpenses let-selected="selected">
  <button mat-menu-item (click)="expensePaidedSelected(selected)">
    <mat-icon>payment</mat-icon><span>Pagar gastos</span>
  </button>
</ng-template>

<ng-template #actionsButtons let-uid="uid">
  <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
    <!-- Ingresos no cobrados -->
    <button mat-menu-item *ngIf="sentence.includes('Ingresos') && row.paided == null"
            (click)="invoicePaided(row.uid, row.receiverName === 'Factura simplificada')">
      <mat-icon>payment</mat-icon><span>Cobrar</span>
    </button>
    <button mat-menu-item *ngIf="sentence.includes('Ingresos') && row.invoiceNumber?.startsWith('FRA')"
            (click)="pdf(row.uid)">
      <mat-icon>picture_as_pdf</mat-icon><span>PDF</span>
    </button>
    <button mat-menu-item *ngIf="sentence.includes('Ingresos') && row.invoiceNumber?.startsWith('TICKET')"
            (click)="pdfTicket(row.uid)">
      <mat-icon>picture_as_pdf</mat-icon><span>PDF</span>
    </button>
    <!-- Gastos no pagados -->
    <button mat-menu-item *ngIf="sentence.includes('Gastos') && row.paided == null"
            (click)="invoicePaidedExpense(row.uid)">
      <mat-icon>payment</mat-icon><span>Pagar</span>
    </button>
    <button mat-menu-item *ngIf="sentence.includes('Gastos') && row.image"
            (click)="downloadFileImage(row.uid)">
      <mat-icon>image</mat-icon><span>Imagen</span>
    </button>
    <button mat-menu-item *ngIf="sentence.includes('Gastos') && row.pdf"
            (click)="downloadFilePdf(row.uid)">
      <mat-icon>attachment</mat-icon><span>Documento</span>
    </button>
    <ng-container *ngIf="sentence.includes('Gastos') && !row.pdf && !row.image && row.paided != null">
      <button mat-menu-item disabled>
        <mat-icon>info_outline</mat-icon><span>Sin documento adjunto</span>
      </button>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #headerActionsButtonsInvoices let-selected="selected">
  <button mat-menu-item (click)="invoicePaidedSelected(selected)">
    <mat-icon>payment</mat-icon><span>Cobrar</span>
  </button>
</ng-template>
